import * as React from 'react';
import { ArgsProvider } from './ArgsContext'
import { Args } from '../types/request-context';
import { DVUIContext, DVUIOverride } from './DVUIContext';

export const wrapperClassName = (name: string) => `DVWebNode-${name}-wrapper`;

export const provideDVUI = (Component: JSX.Element, context: DVUIContext = {}) => (
    <DVUIOverride value={context} > {Component}</DVUIOverride>
);

export const provideContext = <Props extends object>(
    Component: React.ComponentType<Props>,
    context: Args
): React.ComponentType<Props> => {
    return (props: Props) => (
        <ArgsProvider value={context}>
            <Component {...props} />
        </ArgsProvider>
    )
}
